import React from 'react';

/**
 * Wrapper component for the imported component
 * @param ChildComponent
 *  React child component to render
 * @return {function(*=): (function(*): *)|*}
 *  Component || Warning message instead of component
 * @constructor
 */
const UI = (ChildComponent) => (extraProps = {}) => {
  function Component(props) {
    if (!ChildComponent) {
      const componentStyle = {
        background: '#FFB511',
        textAlign: 'center',
        padding: '20px',
        color: 'white',
      };

      const inputStyle = {
        all: 'unset',
        textAlign: 'center',
        background: 'rgba(0,0,0,0.5)',
        padding: '10px',
        marginTop: '5px',
      };

      return (
        <div style={componentStyle}>
          <h1>missing component.</h1>
          <br />
          <div>Run the script bellow to update the UI library</div>
          <input readOnly style={inputStyle} value="yarn update-scl" />
        </div>
      );
    }
    return <ChildComponent {...props} {...extraProps} />;
  }

  return Component;
};

export default UI;
